<div>
  <canvas #chartElement></canvas>
</div>

<!--//jeb if we do put history into popups etc, it would be nice to also export them somehow-->
<!--//jeb download / save icon on the button -->
<button *ngIf="showDownloadButton" (click)="downloadChart()" class="btn btn-outline-blue-grey">Download Chart</button>

<!-- //jeb todo email chart automation <button (click)="emailChart()">Email Chart</button>
<input id="scheduleEmail" type="checkbox" />
<label for="scheduleEmail">Email Chart every Month</label>
<span>
  to
  <input type="text" placeholder="Email Address" />
  <button (click)="emailChartEveryMonth()">Email Chart</button>
</span> -->